import { tns } from "tiny-slider";

const settingsGlobalSlider = {
  slideBy : 'page',
  swipeAngle : false,
  autoplayButtonOutput : false,
  gutter : 30,
  mouseDrag : true,
  loop : true,
  autoplay : false,
  pause : 10000,
  speed : 1000,
  navPosition : 'bottom',
  controlsText : ['<i class="las la-angle-left"></i>', '<i class="las la-angle-right"></i>']
};

$(document).ready(() => {
  /* Custom Page*/
  if ($('body').hasClass('page-template-custom-page')) {
    if ($('.gallery').length && $('.gallery .item').length > 1) {
      let options = {
        items : 1,
        nav : true,
        controls : true,      
        responsive: {
          0 : {
              edgePadding : 0,
              startIndex : 0,
              gutter : 20,
              controls : false
          },
          768 : {
            edgePadding : 0,
            startIndex : 1,
            gutter : 30,
            controls : true
          }
        }
      }

      $('.gallery').each(function (count) {
        let containerGallery = {
            container : '.' + $(this).data('container')
        }
        let gallerySlider = tns(Object.assign({}, containerGallery, settingsGlobalSlider, options));    
      });
    }

    if ($('.related-pages').length) {
      let options = {
        container : '.related-pages',
        items : 3,
        nav : true,
        controls : false,
        responsive: {
          0 : {
              gutter : 20,
              items : 1
          },
          768 : {
            gutter : 30,
            items : 2
          },
          992 : {
            items : 2
          },
          1200 : {
            items : 3
          }
        }
      }
      let relatedPage = tns(Object.assign({}, settingsGlobalSlider, options));    
    }
  }

  /* Home Page*/
  if ($('body').hasClass('home')) {
    if ($('.hero-slider .item').length > 1) {
      let options = {
        items : 1,
        container : '.hero-slider',
        nav : false,
        controls : true
      }

      let heroSlider = tns(Object.assign({}, settingsGlobalSlider, options));
    }

    if ($('.related-slider').length) {
      let options = {
        container : '.related-slider',
        items : 3,
        nav : true,
        controls : false,
        responsive: {
          0 : {
              gutter : 20,
              items : 1
          },
          768 : {
            gutter : 30,
            items : 2
          },
          992 : {
            items : 2
          },
          1200 : {
            items : 3
          }
        }
      }
      let relatedPosts = tns(Object.assign({}, settingsGlobalSlider, options));    
    }

    if ($('.entries-slider').length) {
      let options = {
        items : 1,
        container : '.entries-slider',
        nav : true,
        controls : false,
        loop : false,
        autoplay : false,
        responsive: {
          0 : {
              gutter : 20,
              items : 1.15
          },
          768 : {
            gutter : 30,
            items : 2
          }
        }
      }

      let entriesSlider = tns(Object.assign({}, settingsGlobalSlider, options));
    }
  }

  /* Single */
  if ($('body').hasClass('single')) {
    if ($('.related-slider').length) {
      let options = {
        container : '.related-slider',
        items : 4,
        nav : true,
        controls : false,      
        responsive: {
          0 : {
              edgePadding : 0,
              gutter : 20
          },
          768 : {
            edgePadding : 0,
            gutter : 30
          }
        }
      }
      let relatedPosts = tns(Object.assign({}, settingsGlobalSlider, options));    
    }
  }
});